export function isBrowser() {
    return typeof window !== 'undefined';
}
export function isIE() {
    var _a, _b;
    return isBrowser() && !!((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.match(/MSIE|Trident/));
}
//# sourceMappingURL=browser.js.map